import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1309046b")

_pushScopeId("data-v-1309046b")
const _hoisted_1 = { class: "main-bg" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('详情'))
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_c_search_list = _resolveComponent("c-search-list")
  const _component_el_button = _resolveComponent("el-button")
  const _component_c_table = _resolveComponent("c-table")
  const _component_detailDialog = _resolveComponent("detailDialog")
  const _directive_hasAuth = _resolveDirective("hasAuth")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_c_search_list, {
      inputList: _ctx.inputList,
      onOnSearch: _ctx.handleSearch,
      onOnReset: _ctx.handleReset
    }, null, 8, ["inputList", "onOnSearch", "onOnReset"]), [
      [_directive_hasAuth, 'car-data-query']
    ]),
    _createVNode(_component_c_table, {
      dataSource: _ctx.tableConfig,
      isIndex: true,
      onPageCurrentChange: _ctx.pageCurrentChange,
      onPageSizeChange: _ctx.pageSizeChange
    }, {
      action: _withId((scope) => [
        _createVNode(_component_el_button, {
          type: "text",
          size: "small",
          onClick: ($event: any) => (_ctx.onToggle(scope.row, 'isFlag'))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["dataSource", "onPageCurrentChange", "onPageSizeChange"]),
    (_ctx.isFlag)
      ? (_openBlock(), _createBlock(_component_detailDialog, {
          key: 0,
          modelValue: _ctx.isFlag,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isFlag = $event)),
          row: _ctx.currentRow
        }, null, 8, ["modelValue", "row"]))
      : _createCommentVNode("", true)
  ]))
})